import React from "react";
import ItinerarySidebarBase from "./base";

interface ShowItinerarySidebarAppProps {
  showId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment
  panelConfig: server.dto.ItinerarySidebarPanelConfig
  disableNewAppointments: boolean
  canLinkUnlinkTravel: boolean
}

export const ShowItinerarySidebarApp = (props: ShowItinerarySidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "show", itemId: props.showId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={props.disableNewAppointments}
    canLinkUnlinkTravel={props.canLinkUnlinkTravel}
    canLinkUnlinkShow={false}
    queryKeys="showItinerary"
    canAdd={props.panelConfig.canAdd}
    linkedItems={{
      flightIds: props.panelConfig.linkedFlightIds,
      groundTransportIds: props.panelConfig.linkedGroundTransportIds,
      trainIds: props.panelConfig.linkedTrainSegmentIds,
      showIds: [],
    }}
  />
}

interface GroundTransportSidebarAppProps {
  groundTransportId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment
  queryKeys: string

  linkedShowIds: number[]
}

export const GroundTransportItinerarySidebarApp = (props: GroundTransportSidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "groundTransport", itemId: props.groundTransportId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={false}
    canLinkUnlinkTravel={false}
    canLinkUnlinkShow
    queryKeys={props.queryKeys}
    canAdd
    linkedItems={{
      flightIds: [],
      groundTransportIds: [],
      trainIds: [],
      showIds: props.linkedShowIds,
    }}
  />
}

interface FlightSidebarAppProps {
  flightId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment
  queryKeys: string

  linkedShowIds: number[]
}

export const FlightItinerarySidebarApp = (props: FlightSidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "flight", itemId: props.flightId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={false}
    canLinkUnlinkTravel={false}
    canLinkUnlinkShow
    queryKeys={props.queryKeys}
    canAdd
    linkedItems={{
      flightIds: [],
      groundTransportIds: [],
      trainIds: [],
      showIds: props.linkedShowIds,
    }}
  />
}

interface TrainSidebarAppProps {
  trainId: number
  artist: server.dto.ArtistSmall
  startDate: moment.Moment
  endDate: moment.Moment
  queryKeys: string

  linkedShowIds: number[]
}

export const TrainItinerarySidebarApp = (props: TrainSidebarAppProps) => {
  return <ItinerarySidebarBase
    item={{ type: "train", itemId: props.trainId }}
    artist={props.artist}
    startDate={props.startDate}
    endDate={props.endDate}
    disableNewAppointments={false}
    canLinkUnlinkTravel={false}
    canLinkUnlinkShow
    queryKeys={props.queryKeys}
    canAdd
    linkedItems={{
      flightIds: [],
      groundTransportIds: [],
      trainIds: [],
      showIds: props.linkedShowIds,
    }}
  />
}